import '../App.css';
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CampaignAdCreative from './CampaignAdCreative';
import { loadCampaign, patchCampaign } from '../QueryCampaign';

function CampaignPreview({ campaign_id }) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [campaign, setCampaign] = useState(null);

    useEffect(
        () => {
            const id = campaign_id;
            if (!id) {
                return;
            }

            loadCampaign(id).then(
                (response) => setCampaign(response.data)
            ).catch(
                (error) => navigate('/')
            );
        },
        [],
    )

    if (!campaign) {
        return (
            <div>
                Loading...
            </div>
        );
    }

    return (
        <div align='center'>
            <CampaignAdCreative
                campaign={campaign}
                patchCampaign={
                    () => {
                        patchCampaign(campaign_id).then(
                            (response) => navigate('/campaigns/')
                        ).catch(
                            (error) => navigate('/')
                        )
                    }
                }
            />
        </div>
    )
}

export default CampaignPreview;